import { useCallback, useEffect } from 'react';

export const useOnFullscreenChange = (
    onFullscreenChange: (isFullscreen: boolean) => void,
    { withInitialCall }: { withInitialCall?: boolean } = { withInitialCall: false }
) => {
    const onFullscreenChangeWithoutParams = useCallback(
        () => onFullscreenChange(Boolean(document.fullscreenElement)),
        [onFullscreenChange]
    );

    useEffect(() => {
        if (withInitialCall) {
            onFullscreenChangeWithoutParams();
        }
        document.addEventListener('fullscreenchange', onFullscreenChangeWithoutParams);
        return () => {
            document.removeEventListener('fullscreenchange', onFullscreenChangeWithoutParams);
        };
    }, [onFullscreenChangeWithoutParams, withInitialCall]);
};
